import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db } from "../db";
import { useSelector } from "react-redux";
import { selectCurrency } from "../components/Redux/Slices/currencySlice";
import formInputsJson from "../components/formInputs.json";
import CategoryLists from "../components/CategoryLists";
import { Button } from "react-bootstrap";
 import { NumericFormat } from "react-number-format";
import ErrorSuccessMessage from "../components/ErrorSuccessMessage";

const EditExpense = () => {
  const { expenseId } = useParams();
  const navigate = useNavigate();
  const formInputs = formInputsJson.formInputs;
  const selectedCurrency = useSelector(selectCurrency);
  const [userAddedCategories, setUserAddedCategories] = useState([]);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [progress, setProgress] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [formData, setFormData] = useState({
    item: "",
    quantity: "",
    category: "",
    amount: "",
    currency: "",
    date: "",
  });

  useEffect(() => {
    const fetchExpense = async () => {
      try {
        const expense = await db.expenses.get(parseInt(expenseId, 10));
        if (expense) {
          setFormData({
            item: expense.item,
            quantity: expense.quantity,
            category: parseInt(expense.category),
            amount: expense.amount,
            currency: expense.currency,
            date: expense.date,
          });
        } else {
          console.error("Expense not found");
        }
      } catch (error) {
        console.error("Error fetching expense:", error);
      }
    };
    fetchExpense();
  }, [expenseId]);

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      await db.expenses.update(parseInt(expenseId, 10), {
        ...formData,
        category: parseInt(formData.category, 10),
        isEdited: 1,
      });
      setMessage("Successfully Updated");
      setMessageType("success");
      startCountdown();
      setTimeout(() => navigate(-1), 1000);
    } catch (error) {
      console.error("Error updating expense:", error);
      setMessage("Error updating expense");
      setMessageType("danger");
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "quantity" && value.length > 11) {
      return;
    }

    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prevData) => ({ ...prevData, [name]: value }));
  // };
  const handleCategoryChange = (e) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      category: parseInt(value, 10),
    }));
  };

  useEffect(() => {
    const fetchUserAddedCategories = async () => {
      try {
        const categoriesFromDB = await db.categories.toArray();
        setUserAddedCategories(categoriesFromDB);
      } catch (error) {
        console.error("Error fetching user-added categories:", error);
      }
    };

    fetchUserAddedCategories();
  }, []);

  const [intervalId, setIntervalId] = useState(null);

  const startCountdown = () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
    setIsActive(true);
    setProgress(0);

    let currentProgress = 0;
    const newIntervalId = setInterval(() => {
      currentProgress += 100 / (1 * 10);
      setProgress(currentProgress);
    }, 100);

    setIntervalId(newIntervalId);
  };

  return (
    <div className="container p-2 pt-4 main-div ">
      <div className="display-center pb-4">
        <button
          className="btn verticalAlign position-absolute start-0 "
          onClick={() => {
            navigate(-1);
          }}
        >
          <span className="fs-1  material-symbols-outlined">
            chevron_backward
          </span>
        </button>
        <h3 className=" verticalAlign heading-txt">Update Expense</h3>
      </div>

      <div className="card child-div    ">
        <form onSubmit={handleSave}>
          <div className="row pb-5 ">
            {formInputs.map((input, index) => (
              <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-2">
                {input.type === "select" ? (
                  <div>
                    <label htmlFor={input.id} className="form-label">
                      {input.label}
                    </label>
                    <CategoryLists
                      categories={userAddedCategories?.filter(
                        (category) => category.isDeleted !== 1
                      )}
                      selectedParent={{ id: formData.category }}
                      onChange={handleCategoryChange}
                    />
                  </div>
                ) : (
                  <div>
                    <label htmlFor={input.id} className="form-label">
                      {input.label}
                    </label>
                    {input.name === "amount" ? (
                      <NumericFormat
                        value={formData.amount}
                        decimalScale={2}
                        onValueChange={(values) => {
                          const { value } = values;
                          setFormData((prevData) => ({
                            ...prevData,
                            amount: value,
                          }));
                        }}
                        thousandsGroupStyle="lakh"
                        thousandSeparator=","
                        prefix={selectedCurrency.label}
                        placeholder={input.placeholder}
                        className="form-control currencyIcons"
                        required={input.required}
                        onKeyDown={(e) => {
                          // Allow backspace and delete
                          if (e.key === "Backspace" || e.key === "Delete")
                            return;

                          // Check if the input already has 10 digits
                          const currentDigits = e.target.value.replace(
                            /\D/g,
                            ""
                          ).length;
                          if (currentDigits >= 10) {
                            e.preventDefault(); // Prevent further input
                          }
                        }}
                      />
                    ) : (
                      <input
                        type={input.type}
                        id={input.id}
                        name={input.name}
                        value={formData[input.name]}
                        onChange={
                          input.name === "category"
                            ? handleCategoryChange
                            : handleChange
                        }
                        className="form-control"
                        placeholder={input.placeholder}
                        required={input.required}
                      />
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className=" display-center pt-3 pb-4 ">
            <Button
              className="save-btn  btn rounded-pill"
              variant="success"
              type="submit"
            >
              <span className="material-symbols-outlined verticalAlign me-2">
                save
              </span>
              <span className="verticalAlign">Save</span>
            </Button>
          </div>

          <ErrorSuccessMessage
            message={message}
            messageType={messageType}
            isActive={isActive}
            progress={progress}
          />

          {/* <span className="noSpace SuccessMessage-div">
            {message && (
              <div
                className={` successMessage ${
                  messageType === "success" ? "alert-success" : "alert-danger"
                }`}
              >
                <span className="material-symbols-outlined ">
                  task_alt
                </span>
                <span className=""> {message} </span>
              </div>
            )}
          </span> */}
        </form>
      </div>
    </div>
  );
};

export default EditExpense;
